/**
 * Created by yangxx on 2017/10/21.
 * 引线标注组件
 */
/**
 * 引线标注组件
 * @module TailedLabelComponent
 */
'use strict';
define([
    '../../base/PureComponent',
    './TailedLabel',
    '../../utils/CommonUtil',
    '../../utils/LayerUtil',
    '../../utils/RenderUtil',
    '../../utils/SpatialOPUtil',
    '../../utils/GeometryUtil',
    '../../g2'
], function (PureComponent,
             TailedLabel,
             CommonUtil,
             LayerUtil,
             RenderUtil,
             SpatialOPUtil,
             GeometryUtil,
             g2) {
    /**
     * @constructor
     * @classdesc 引线标注组件
     * @augments G.base.PureComponent
     * @alias G.components.TailedLabelComponent
     * @param options {Object} 必填
     * @param options.map {G.Map} 必填，地图对象
     * @param options.layerId {String} 可选，引线图层id，不传自动创建新图层
     * @param options.tailLength {Number} - 可选，引线长度，单位像素
     * @param options.tailAlign {String} - 可选，引线在标注上的位置，可选值 auto：自动在角上，center：水平方向居中
     * @param options.tailAngle {Number} -可选，引线与所指图形上的锚点的正北方向沿顺时针方向的夹角，单位度
     * @param options.symbol {Object} -可选，引线样式
     * @param options.showArrow {Boolean} -可选，是否显示箭头，默认为false
     * @param options.arrowSymbol {Object} -可选，箭头样式，默认与引线样式一致
     * @param options.arrowShape {String} -可选，箭头形状，默认为'triangle'，
     *          可选值为'line'=线、'triangle'=三角形
     * @param options.arrowLength {Number} 可选，箭头长度
     * @param options.arrowScale {Number} 可选，箭头长与线段长度比，默认为0.2；
     *          只有未指定arrowLength参数的情况下此参数才有效；
     * @param options.arrowAngle {Number} 可选，箭头与线段夹角，单位为度，默认为30度
     * @param options.domClassName {String} -可选，容器样式，默认为空
     * @param options.domStyle {Object} -可选，容器样式，默认为空
     * @param options.collision {String} 可选，重叠的处理，默认为'visibility',可选值为'none'=不处理；'visibility'=隐藏重叠的标注；
     *
     * @example
     *    var tailedLabelComponent=new G.components.TailedLabelComponent({
                map:map,
                layerId:'tailed-marker-layer',
//                collision:'none',
                symbol:{
                    type:'SimpleLineSymbol',
                    options:{
                        "color": {
                            "alpha": 250,
                            "r": 0,
                            "g": 0,
                            "b": 0
                        },
                        "style": 5,
                        "width": 1
                    }
                },
                //引线长度
                tailLength:80,
                //dom样式名
                domClassName:'emap-tail-label',
                //引线偏移正北方向的角度
                tailAngle:45,
                //是否显示箭头
                showArrow:true,
                //箭头形状，默认为三角形
//                arrowShape:'line',
                //箭头与引线夹角
                arrowAngle:30,
                //箭头长度比例
                arrowScale:0.15
            });
     */
    var component = PureComponent.extend({
        options: {
            collision: 'visibility',
            //线符号
            symbol: {
                type: 'SimpleLineSymbol',
                options: {
                    "color": {
                        "a": 250,
                        "r": 0,
                        "g": 0,
                        "b": 0
                    },
                    "style": 5,
                    "width": 2
                }
            }
        },
        initialize: function (options) {
            PureComponent.prototype.initialize.call(this, options);
            //维护所有标注
            this._tailLables = [];
            //标注引线参数
            this._tailOpts = {
                tailLength: true,
                tailAlign: true,
                tailAngle: true,
                symbol: true,
                showArrow: true,
                arrowSymbol: true,
                arrowShape: true,
                arrowLength: true,
                arrowScale: true,
                arrowAngle: true,
                domClassName: true,
                domStyle: true
            };
            this._lastLevel = this.map.getZoomLevel();
            this.map.listen('extentchanged', this._onExtentChange, this);
            // ol map  drag
            try {
                this.map.map.listen('pointerdrag', this._onMapDragg, this);
            } catch (e) {}
            
        },
        clear: function () {
            for (var i = 0, len = this._tailLables.length; i < len; i++) {
                try {
                    this._tailLables[i].destroy();
                } catch (e) {}
            }
            this._tailLables = []
        },
        destroy: function () {
            this.map.off('extentchanged', this._onExtentChange, this);
            //ol drag
            try {
                this.map.map.un('pointerdrag', this._onMapDragg, this);
            } catch (e) {}
            
            PureComponent.prototype.destroy.call(this);
        }
    });
    /**
     * 内部方法
     */
    component.include({
        _onExtentChange: function (event) {
            var funName = '';
            //比例尺没变
            if (this._lastLevel == this.map.getZoomLevel()) {
                funName = 'updateDom';
            } else { //缩放时才更新引线
                funName = 'update';
            }
            for (var i = 0, len = this._tailLables.length; i < len; i++) {
                try {
                    this._tailLables[i][funName]();
                } catch (e) {}
            }
            this._lastLevel = this.map.getZoomLevel();
            //
            this._detectCollision();
        },
        _onMapDragg: function (event) {
            var pixel = event.pixel,
                coordinate = event.coordinate;
            for (var i = 0, len = this._tailLables.length; i < len; i++) {
                try {
                    this._tailLables[i].updateDom();
                } catch (e) {}
            }
            this._detectCollision();
        },
        //覆盖处理
        _detectCollision: function () {
            var collision = this.options.collision;
            var map = {
                'none': function () {
                
                },
                'visibility': function () {
                    var list = [];
                    for (var i = 0, len = this._tailLables.length; i < len; i++) {
                        var tail = this._tailLables[i];
                        if (detect(tail, list)) {
                            tail.toggleVisible(false);
                        } else {
                            tail.toggleVisible(true);
                            list.push(tail);
                        }
                    }
                    
                    function detect(obj, arr) {
                        var flag = false;
                        for (var k = 0, ll = arr.length; k < ll; k++) {
                            var tail = arr[k];
                            if (obj.intersects(tail)) {
                                flag = true;
                                break;
                            }
                        }
                        return flag;
                    }
                }
            };
            map[collision].call(this);
        },
        /**
         * 获取地图
         * @private
         */
        _getLayer: function () {
            if (!this._layer) {
                var layerId = this.options.layerId,
                    layer = LayerUtil.getLayerById(this.map, layerId);
                if (!layer) {
                    layer = new g2.carto.ElementLayer({
                        map: this.map,
                        id: layerId
                    });
                    this.map.addLayer(layer);
                }
                this._layer = layer;
            }
            return this._layer;
        },
        /**
         * 根据id获取
         * @param id {String} 必填，引线标注id
         */
        _getTailedLabel: function (id) {
            var result = null;
            for (var i = this._tailLables.length - 1; i >= 0; i--) {
                var taileLabel = this._tailLables[i];
                if (taileLabel && taileLabel.getId() == id) {
                    result = taileLabel;
                    break;
                }
            }
            return result;
        },
    });
    
    /**
     * 对外接口
     */
    component.include({
        /**
         * 添加
         * @method
         * @memberOf G.components.TailedLabelComponent.prototype
         * @param opts {Object} 必填
         * @param opts.label {String} -　必填，文本内容
         * @param opts.geometry {wkt/GeoJSON} -　必填，引线指向图形坐标，要求坐标系与map一致
         * @param opts.tailLength {Number} - 必填，引线长度，单位像素，默认为组件初始化的对应参数值
         * @param opts.tailAlign {String} - 可选，引线在标注上的位置，可选值 auto：自动在角上，center：水平方向居中
         * @param opts.tailAngle {Number} -必填，引线与所指图形上的锚点的正北方向沿顺时针方向的夹角，单位度，默认为组件初始化的对应参数值
         * @param opts.symbol {Object} -可选，引线样式，默认为组件初始化的对应参数值
         * @param opts.showArrow {Boolean} -可选，是否显示箭头，默认为组件初始化的对应参数值
         * @param opts.arrowSymbol {Object} -可选，箭头样式，默认为组件初始化的对应参数值
         * @param opts.arrowShape {String} -可选，箭头形状，默认为组件初始化的对应参数值
         * @param opts.arrowLength {Number} 可选，箭头长度，默认为组件初始化的对应参数值
         * @param opts.arrowScale {Number} 可选，箭头长与线段长度比，默认为组件初始化的对应参数值
         * @param opts.arrowAngle {Number} 可选，箭头与线段夹角，单位为度，默认为组件初始化的对应参数值
         * @param opts.domId {String} -可选，容器id，默认自动生成uuid
         * @param opts.domClassName {String} -可选，容器样式，默认为组件初始化的对应参数值
         * @param opts.domStyle {Object} -可选，容器样式，默认为空
         * @returns {String} 引线标注的id
         */
        add: function (opts) {
            var options = jQuery.extend(true, {}, opts);
            for (var key in this._tailOpts) {
                options[key] = options[key] || this.options[key];
            }
            options.layer = this._getLayer();
            options.map = this.map;
            var tailedLabel = new TailedLabel(options);
            tailedLabel.setContent(options.label);
            this._tailLables.push(tailedLabel);
            //
            this._detectCollision();
            return tailedLabel.getId();
        },
        /**
         * 更新
         * @method
         * @memberOf G.components.TailedLabelComponent.prototype
         * @param id {String} 必填，要更新的引线标注id
         * @param label {String} 必填，更新的文本内容
         * @param opts {Object} 可选，更新文本的配置
         * @returns {Boolean}
         */
        update: function (id, label, opts) {
            var flag = false;
            var tailedLabel = this._getTailedLabel(id);
            if (tailedLabel != null) {
                tailedLabel.setContent(label);
                if (opts != undefined) {
                    tailedLabel.update(opts || {});
                }
                flag = true;
            }
            return flag;
        },
        /**
         * 移除
         * @method
         * @memberOf G.components.TailedLabelComponent.prototype
         * @param id {String} 必填，要移除的引线标注id
         * @returns {Boolean}
         */
        remove: function (id) {
            var flag = false;
            for (var i = this._tailLables.length - 1; i >= 0; i--) {
                var taileLabel = this._tailLables[i];
                if (taileLabel && taileLabel.getId() == id) {
                    taileLabel.destroy();
                    this._tailLables.splice(i, 1);
                    flag = true;
                    break;
                }
            }
            for (var n = this._layer.elements.length - 1; n >= 0; n--) {
                var ele = this._layer.elements[n];
                if (ele && ele.id == id) {
                   this._layer.remove(ele);
                   break;
                }
            }
            return flag;
        },
        
        /**
         * 移除所有
         * @method
         * @memberOf G.components.TailedLabelComponent.prototype
         */
        removeAll: function () {
            for (var i = this._tailLables.length - 1; i >= 0; i--) {
                var tailLabel = this._tailLables[i];
                if (tailLabel) {
                    tailLabel.destroy();
                    this._tailLables.splice(i, 1);
                }
            }
            
            this._layer.clear();
        },
        getLayer: function () {
            return this._getLayer();
        },
    });
    return component;
});